import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ApplicationPackage} from '../../../enums/application-package.enum';
import {Service} from '../../../enums/service.enum';
import { environment } from 'src/environments/environment';
import { TranscodePreset } from 'src/app/model/transcode-preset.model';
import { VideoFormats } from 'src/app/constants/general-constants';
import { Observable } from 'rxjs';
import { CustomHttpUrlEncodingCodec } from 'src/app/main/encoder';

@Injectable({
  providedIn: 'root'
})
export class TranscodePresetsService {
  readonly transcodePresetsUrl = environment.endPoint + ApplicationPackage.CMS_VOD + Service.ENCODER;

  constructor(private http: HttpClient) { }

  getAllTranscodePresets(name?: string, transcodeFormat?: string, sortParams?: string[]): Observable<TranscodePreset[]> {
    let queryParams: HttpParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

    if (name) {
      queryParams = queryParams.set('name', name);
    }

    if (transcodeFormat) {
      queryParams = queryParams.set('transcodeFormat', transcodeFormat);
    }

    if (sortParams) {
      queryParams = queryParams.set('sortParam', sortParams.join(','));
    }

    return this.http.get<TranscodePreset[]>(this.transcodePresetsUrl + '/transcodepresets' +'/', {params: queryParams});
  }

  getTranscodePresetById(transcodePresetId: number): Observable<TranscodePreset> {
    return this.http.get<TranscodePreset>(this.transcodePresetsUrl + `/transcodepreset/${transcodePresetId}`);
  }

  createTranscodePreset(transcodePreset: {transcodePreset: TranscodePreset }): Observable<TranscodePreset> {
    return this.http.post<TranscodePreset>(this.transcodePresetsUrl + '/transcodepreset/', transcodePreset);
  }

  updateTranscodePreset(transcodePreset: TranscodePreset): Observable<TranscodePreset> {
    return this.http.put<TranscodePreset>(this.transcodePresetsUrl + '/transcodepreset/', transcodePreset);
  }

  deleteTranscodePreset(transcodePresetId: number): Observable<any> {
    return this.http.delete<any>(this.transcodePresetsUrl + `/transcodepreset/${transcodePresetId}`);
  }
}
